export default "__VITE_PUBLIC_ASSET__c3472de6__"